import React from 'react';
import randomstring from 'uuid/v4';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AddIcon } from '../../../images/icons/WrapSvg';
import MessagesApi from '../../../api/MessagesApi';
import CommunicationApi from '../../../api/CommunicationsApi';

class File extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            isLoading: false
        };
    }

    async handleChange(e) {

        this.onStart();

        // get the files
        let files = this.props.multiple ? [...e.target.files] : [e.target.files[0]];

        // Process each file
        var allFiles = [];
        for (const file of files) {
            const key = randomstring();
            console.log(file);
            let fileInfo = {
                name: file.name,
                type: file.type
                    ? file.type
                    : file.name.endsWith('.xls')
                        ? 'application/vnd.ms-excel'
                        : 'text/plain',
                size: file.size,
                link: file,
                comentario: file.name,
                key: key,
            };
            if (this.props.communication) {
                await CommunicationApi.uploadFile(this.props.id, fileInfo)
                    .then((url) => {
                        allFiles.push(url);
                        if (allFiles.length === files.length) {
                            this.onEnd();
                            fileInfo.id = url;
                            this.props.onDone({ id: url, nombre: fileInfo.name, tipo: fileInfo.type, tamano: fileInfo.size });
                        }
                        return url;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.props.showError(error.message, error.type);
                    });
            } else {
                await MessagesApi.uploadFile(this.props.id, fileInfo)
                    .then((url) => {
                        allFiles.push(url);
                        if (allFiles.length === files.length) {
                            this.onEnd();
                            fileInfo.id = url;
                            this.props.onDone({ id: url, nombre: fileInfo.name, tipo: fileInfo.type, tamano: fileInfo.size });
                        }
                        return url;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.props.showError(error.message, error.type);
                    });
            }
        }

    }

    onStart = () => {
        this.setState({ isLoading: true });
    }

    onEnd = () => {
        this.setState({ isLoading: false });
    }

    render() {
        const { isLoading } = this.state;

        return (
            <div className="upload-btn-wrapper margin_top_9 hand">
                {isLoading && (
                    <CircularProgress size={64} className={'fabProgress64 c_bluish'} />
                )}
                <button className="btn bg_ice_blue">
                    <AddIcon width={16} heigth={16} color={'primary'} />
                </button>
                <input
                    type="file"
                    onChange={this.handleChange.bind(this)}
                    multiple={this.props.multiple}
                    data-max-size="10013756"
                />
            </div>

        );
    }
}

File.defaultProps = {
    multiple: false,
};

export default File;


// WEBPACK FOOTER //
// ./src/components/complex/communications/FileUpload.js